import { VariantProps, cva } from "class-variance-authority";
import { cn } from "cy-fe/src/utils/cn";
import type { ReactNode } from "react";

const styles = cva(["font-header"], {
  variants: {
    vStyle: {
      h1: ["mb-5 text-xl sm:text-2xl font-semibold text-primary "],
      h2: ["text-lg sm:text-xl font-semibold text-primary "],
      h3: ["text-lg font-bold text-primary sm:text-xl"],
      h4: ["text-normal font-bold text-primary sm:text-lg"],
      h5: ["text-sm font-semibold text-black border-b pb-2 mb-5 "],
      h6: ["text-normal font-bold text-black border-b "],
    },
    vCenter: {
      true: ["mx-auto w-fit text-center"],
      false: [""],
    },
  },
});

export function HeaderText({
  children,
  className,
  type,
  vStyle,
  vCenter,
}: {
  children: ReactNode;
  className?: string;
  type?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
} & VariantProps<typeof styles>) {
  // default to h1 if none specified
  if (type == null) {
    type = vStyle || "h1";
  }
  if (vStyle == null) {
    vStyle = type;
  }
  return (
    <>
      {type === "h1" ? (
        <h1 className={cn(styles({ vStyle, vCenter }), className)}>
          {children}
        </h1>
      ) : type === "h2" ? (
        <h2 className={cn(styles({ vStyle, vCenter }), className)}>
          {children}
        </h2>
      ) : type === "h3" ? (
        <h3 className={cn(styles({ vStyle, vCenter }), className)}>
          {children}
        </h3>
      ) : type === "h4" ? (
        <h4 className={cn(styles({ vStyle, vCenter }), className)}>
          {children}
        </h4>
      ) : type === "h5" ? (
        <h5 className={cn(styles({ vStyle, vCenter }), className)}>
          {children}
        </h5>
      ) : (
        <h6 className={cn(styles({ vStyle, vCenter }), className)}>
          {children}
        </h6>
      )}
    </>
  );
}
